/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";

const Footer = ({ showGallery = true }) => {
const { t } = useTranslation();
const [expanded, setExpanded] = useState(false);
const phoneNumber = "905553735627"; // Hedef telefon numarası
const [isMenuOpen, setIsMenuOpen] = useState(false);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [isSearchOpen, setIsSearchOpen] = useState(false);

const toggleNav = () => {
setExpanded(!expanded);
};

const scrollToTop = () => {
window.scrollTo(0, 0);
setExpanded(false);
};

const openWhatsApp = (e) => {
e.preventDefault();
const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
"Merhaba, size bir mesaj gönderiyorum!"
)}`;

// Yeni pencerede WhatsApp iletişim penceresini aç
window.open(whatsappURL, "_blank");
};

const handleClick = () => {
window.scrollTo(0, 0);
setIsMenuOpen(false);
setIsSidebarOpen(false);
setIsSearchOpen(false);
};

const images = [
{
small: "assets/images/footer/1.webp",
big: "assets/images/20-kg/1.webp",
},
{
small: "assets/images/footer/2.webp",
big: "assets/images/20-kg/2.webp",
},
{
small: "assets/images/footer/3.webp",
big: "assets/images/20-kg/3.webp",
},
{
small: "assets/images/footer/4.webp",
big: "assets/images/20-kg/4.webp",
},
{
small: "assets/images/footer/5.webp",
big: "assets/images/20-kg/5.webp",
},
{
small: "assets/images/footer/6.webp",
big: "assets/images/20-kg/6.webp",
},
];

return (
<>
  <style>
    {
      ` .social-icon:hover {
        background-color: white !important;
        color: #10adad !important;
        border: 2px solid #10adad !important;
      }

      `
    }
  </style>
  <footer class="main-footer">
    <div class="main-footer__bg" style={{
            backgroundImage: "url(assets/images/shapes/contact-bg-1-1.webp",
          }}></div>
    <div class="container">
      <div class="main-footer__top">
        <div class="row gutter-y-0 justify-content-center align-items-center"
          style={{margin: '0 auto', padding: '0 15px'}}>
          <div class="col-12 text-center wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="100ms">
            <Link as={Link} to="/" class="main-footer__logo d-inline-block mb-0" onClick={scrollToTop}>
            <img src="assets/images/Beyaz-seymen-logo.webp" width="250" alt="Seymen-kimya"
              style={{display: 'block', margin: '0 auto'}} />
            </Link>
          </div>
          {/* <div class="col-12 text-center wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
            <div class="footer-widget__social d-flex justify-content-center align-items-center gap-3"
              style={{margin: '0 auto', width: 'fit-content'}}>
              <a href="../index-3.htm" class="d-flex align-items-center justify-content-center social-icon"
                style={{width: '50px', height: '50px', backgroundColor: '#10adad', borderRadius: '50%', color: 'white', textDecoration: 'none', transition: 'all 0.3s ease'}}>
                <i class="fab fa-facebook-f" aria-hidden="true"></i>
                <span class="sr-only">Facebook</span>
              </a>
              <a href="https://twitter.com" class="d-flex align-items-center justify-content-center social-icon"
                style={{width: '50px', height: '50px', backgroundColor: '#10adad', borderRadius: '50%', color: 'white', textDecoration: 'none', transition: 'all 0.3s ease'}}>
                <i class="fab fa-twitter" aria-hidden="true"></i>
                <span class="sr-only">Twitter</span>
              </a>
              <a href="../index-6.htm" class="d-flex align-items-center justify-content-center social-icon"
                style={{width: '50px', height: '50px', backgroundColor: '#10adad', borderRadius: '50%', color: 'white', textDecoration: 'none', transition: 'all 0.3s ease'}}>
                <i class="fab fa-linkedin-in" aria-hidden="true"></i>
                <span class="sr-only">Linkedin</span>
              </a>
              <a href="../index-7.htm" class="d-flex align-items-center justify-content-center social-icon"
                style={{width: '50px', height: '50px', backgroundColor: '#10adad', borderRadius: '50%', color: 'white', textDecoration: 'none', transition: 'all 0.3s ease'}}>
                <i class="fab fa-youtube" aria-hidden="true"></i>
                <span class="sr-only">Youtube</span>
              </a>
            </div>
          </div> */}
        </div>
      </div>
      <div class="main-footer__widget">
        <div class="row gutter-y-50 justify-content-center" style={{paddingRight: '140px'}}>
          <div class="col-lg-3 col-md-6 col-xl-2 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
            <div class="footer-widget footer-widget--links">
              <h2 class="footer-widget__title">KURUMSAL</h2>
              <ul class="list-unstyled footer-widget__links">
                <li>
                  <Link as={Link} to="/" onClick={scrollToTop}>
                  Anasayfa
                  </Link>
                </li>
                <li>
                  <Link as={Link} to="/kurumsal" onClick={scrollToTop}>
                  Hakkımızda
                  </Link>
                </li>
                <li>
                  <Link as={Link} to="/urunlerimiz" onClick={scrollToTop}>
                  Ürünlerimiz
                  </Link>
                </li>
                <li>
                  <Link as={Link} to="/iletisim" onClick={scrollToTop}>
                  İletişim
                  </Link>
                </li>
              </ul>

              <br />
              <div className="mobile-nav__social" style={{margin: '10px 0', width: 'fit-content'}}>
                <a
                  href="https://www.instagram.com/seymenkimya/"
                  aria-hidden="true"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex align-items-center justify-content-center social-icon"
                  style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: '#10adad',
                    borderRadius: '50%',
                    color: 'white',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <i className="fab fa-instagram" aria-hidden="true"></i>
                  <span className="sr-only">Instagram</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xl-3 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
            <div class="footer-widget footer-widget--links">
              <h2 class="footer-widget__title">ÜRÜNLERİMİZ</h2>
              <ul class="list-unstyled footer-widget__links">
                <li>
                  <Link to="/bulasikmakinedeterjanlari" onClick={handleClick}>{t('Bulaşık M. Deterjanları')}
                  </Link>
                </li>
                <li>
                  <Link to="/ProductSimilarCamasirsulari" onClick={handleClick}>{t('Çamaşır Suları')}</Link>
                </li>
                <li>
                  <Link to="/productsimilarsivielsabunlari" onClick={handleClick}>{t('Sıvı El Sabunları')}</Link>
                </li>
                <li>
                  <Link to="/yuzeytemizlikmaddesi" onClick={handleClick}>{t('Yüzey Temizlik Maddesi')}</Link>
                </li>
                <li>
                  <Link to="/sanayitipiyagcozucu" onClick={handleClick}>{t('Sanayi Tipi Yağ Çözücü')}</Link>
                </li>
                <li>
                  <Link to="/kireccozucu" onClick={handleClick}>{t('Kireç Çözücü')}</Link>
                </li>
                <li>
                  <Link to="/wcbanyotemizleyici" onClick={handleClick}>{t('Wc Banyo Temizleyici')}</Link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xl-4 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="400ms">
            <div class="footer-widget footer-widget--contact">
              <h2 class="footer-widget__title">iletişim</h2>
              <div class="footer-widget__contact">
                <address class="footer-widget__address">
                  Bursa Gıda Toptancılar Sitesi,
                  <br />
                  Ertuğrul Mh. 105. Sk. No:2, 16120 Nilüfer/Bursa
                </address>
                <ul class="list-unstyled footer-widget__info">
                  <li>
                    <span class="icon-paper-plane"></span>{" "}
                    <a href="mailto:info@seymen.com.tr">
                      info@seymen.com.tr
                    </a>
                  </li>
                  <li>
                    <span class="icon-phone-call"></span>{" "}
                    <a href="tel:+905553735627">+90 555 373 56 27</a>
                  </li>
                  <li>
                    <span class="icon-phone-call"></span>{" "}
                    <a href="tel:+905393636862">+90 539 363 68 62</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {showGallery && (
          <div class="col-lg-3 col-md-6 col-xl-3 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="600ms">
            <div className="footer-widget footer-widget--gallery">
              <h2 className="footer-widget__title">GALERİ</h2>
              <SRLWrapper>
                <div className="footer-widget__gallery">
                  {images.map((image, index) => (
                  <div key={index} className="footer-widget__gallery__item">
                    <a href={image.big} data-attribute="SRL">
                      <img src={image.small} alt={`Galeri ${index + 1}`}
                        className="rounded-circle border border-light p-2" />
                      <span className="footer-widget__gallery__icon icon-plus"></span>
                    </a>
                  </div>
                  ))}
                </div>
              </SRLWrapper>
            </div>
          </div>
          )}
        </div>
      </div>
    </div>

    <div class="main-footer__bottom">
      <div class="container">
        <div class="main-footer__bottom__inner">
          <p className="main-footer__copyright">
            <span className="dynamic-year">&copy;2025 -</span> Seymen Kimya Temizlik Ürünleri <br />
            <span className="footer-rights mt-2">Tüm Hakları Saklıdır.</span> <br />
            <span className="footer-webcenter mt-2">
              Web Tasarım: <a href="https://webcenter.com.tr" target="_blank" rel="noopener noreferrer">WebCenter</a>
            </span>
          </p>
        </div>
      </div>
    </div>
  </footer>

  <a href="#" className="back d-flex align-items-center justify-content-center active" alt="Up-down"
    aria-label="Up-down">
    <i className="fas fa-arrow-up"></i>
    <svg className="whatsapp-button__circle" width="100%" height="100%" viewBox="-1 -1 102 102">
      <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
    </svg>
  </a>

  <a href="#" className="whatsapp-button" onClick={openWhatsApp} rel="noopener noreferrer" alt="Whatsapp"
    aria-label="Whatsapp">
    <i className="fab fa-whatsapp"></i>
    <svg className="whatsapp-button__circle" width="100%" height="100%" viewBox="-1 -1 102 102">
      <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
    </svg>
  </a>
</>
);
};

export default Footer;
